export const NUMBERS_AND_LETTERS_ONLY: RegExp = /^[a-zA-Z0-9]*$/
export const NUMBERS_LETTERS_AND_DASHES_ONLY: RegExp = /^[a-zA-Z0-9-]*$/
export const NUMBERS_LOWERCASE_LETTERS_AND_DASHES_ONLY: RegExp = /^[a-z0-9-]*$/
export const EMAIL: RegExp = /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i

/** Matches emojis - Used for i.e. stripping emojis from strings */
export const EMOJIS: RegExp = /\p{Emoji_Presentation}/gmu
